export default __webpack_public_path__ + "static/media/blog-xl-5.e88ab87a.png";